import BattingRankingStats from "./BattingRankingStats.js";
import GeneralRankingStats from "./GeneralRankingStats.js";
import PitchingRankingStats from "./PitchingRankingStats.js";

const RankingScopeContext = {
    General:    { key: 'general',   name: 'General',    enum: GeneralRankingStats },
    Pitching:   { key: 'pitching',  name: 'Pitching',   enum: PitchingRankingStats },
    Batting:    { key: 'batting',   name: 'Batting',    enum: BattingRankingStats },
    Running:    { key: 'running',   name: 'Running',    enum: null },
    Fielding:   { key: 'fielding',  name: 'Fielding',   enum: null },
    Catching:   { key: 'catching',  name: 'Catching',   enum: null },
};

export default RankingScopeContext;